import axios from 'axios'
import { REACT_APP_PERITADOR_API } from 'cfgCommon/config';

export async function repeatTakingCarRequest(data) {
  const body = { requestsId :data }
  const response = await axios.post(`${REACT_APP_PERITADOR_API}/requests/repeat-request/`,body)

  return response.data
}